import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

/**
 * Central de Suporte.
 *
 * O atendimento acontece no portal do TomTicket: aqui só pedimos ao backend a
 * URL de acesso a esse portal. A URL carrega um token de login de curta
 * duração, então não é guardada em storage nem logada.
 */

const getSession = () => {
  const storageRaw = sessionStorage.getItem('ddesp');
  if (!storageRaw) return { emp: 0, uid: 0, token: '' };

  const users = JSON.parse(base64_decode(storageRaw));
  return {
    emp: users?.[0] || 0,
    uid: users?.[3] || 0,
    token: users?.[14] || '',
  };
};

/**
 * Monta o envelope pp/ll/dd esperado pelo espiaoCtrl e dispara a requisição.
 */
const chamarCtrl = (tipo, acao, payload, token, emp, uid) =>
  new Promise((resolve, reject) => {
    try {
      const dataPost_ = [
        base64_encode(String(emp)),
        base64_encode(String(uid)),
        base64_encode(JSON.stringify(payload || {})),
      ];

      $.ajax({
        url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
        type: tipo,
        dataType: 'json',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: {
          pp: base64_encode('tickets'),
          ll: base64_encode(acao),
          dd: base64_encode(JSON.stringify(dataPost_)),
        },
        success: function (data) {
          // Nesses dois casos o roteador responde uma string simples, não o
          // envelope base64. Repassamos intacta para o interceptor do axios
          // fazer o logout; tentar decodificar viraria "Resposta inválida".
          if (data === 'sessao_expirada' || data === 'erro_auth') {
            resolve([200, data]);
            return;
          }

          try {
            resolve([200, JSON.parse(base64_decode(data))]);
          } catch {
            reject([400, { message: 'Resposta inválida do servidor', details: String(data).slice(0, 300) }]);
          }
        },
        error: function (xhr) {
          const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
          reject([400, { message: 'Falha na requisição', details: String(details || '').slice(0, 300) }]);
        },
      });
    } catch (err) {
      reject([500, { message: String(err) }]);
    }
  });

export const RestTicketsGet = async (config) => {
  const caminho = (config?.dest || '').trim();
  const { emp, uid, token } = getSession();

  switch (caminho) {
    case 'diag':
    case 'debug':
      return chamarCtrl('Get', 'diag', config?.dataPost, token, emp, uid);

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota GET não encontrada' }]));
  }
};

export const RestTicketsPost = async (config) => {
  // No POST o axios serializa o body, então config.data chega como string JSON.
  let body = {};
  try {
    body = typeof config?.data === 'string' ? JSON.parse(config.data) : config?.data || {};
  } catch {
    body = {};
  }

  const caminho = (body?.dest || config?.dest || '').trim();
  const { emp, uid, token } = getSession();

  switch (caminho) {
    /* Gera a URL de acesso ao portal do TomTicket, provisionando o que faltar. */
    case 'acesso':
    case 'portal':
      return chamarCtrl('POST', 'acesso', body?.dataPost, token, emp, uid);

    /* Token de SSO e parâmetros do widget de chat, para abrir já identificado. */
    case 'chat':
    case 'chatonline':
      return chamarCtrl('POST', 'chat', body?.dataPost, token, emp, uid);

    /* Identidade assinada para o chat do comercial (contas em demonstração). */
    case 'tawk':
      return chamarCtrl('POST', 'tawk', body?.dataPost, token, emp, uid);

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota POST não encontrada' }]));
  }
};
